import type { RescheduleScheduling } from '@src/core/buyerApiClient';
import type { SchedulingsByDate } from '@src/domains/sale-items/core/reschedule/types';

export function groupAvailableRescheduleSchedulingsByDate(reschedulings: RescheduleScheduling[]): SchedulingsByDate {
  return reschedulings.reduce<SchedulingsByDate>((carry, scheduling) => {
    if (scheduling.scheduleAvailabilities.every((ast) => !ast.available)) {
      return carry;
    }

    return {
      ...carry,
      [scheduling.date]: [...(carry[scheduling.date] ?? []), scheduling],
    };
  }, {});
}
